export const crt = `-----BEGIN CERTIFICATE-----
MIID7zCCAtegAwIBAgIUKMNx8PTy0oZWJ3X6R42Z/qr3wTswDQYJKoZIhvcNAQEL
BQAwgYUxCzAJBgNVBAYTAkFSMQ0wCwYDVQQIDARCc0FzMQ0wCwYDVQQHDARDQUJB
MRAwDgYDVQQKDAdDcm93ZGVyMRAwDgYDVQQLDAdDcm93ZGVyMRAwDgYDVQQDDAdD
cm93ZGVyMSIwIAYJKoZIhvcNAQkBFhNpbmZvQGdldGNyb3dkZXIuY29tMCAXDTIy
MDIwODE5MjEyNVoYDzIwNTMwODAzMTkyMTI1WjCBhTELMAkGA1UEBhMCQVIxDTAL
BgNVBAgMBEJzQXMxDTALBgNVBAcMBENBQkExEDAOBgNVBAoMB0Nyb3dkZXIxEDAO
BgNVBAsMB0Nyb3dkZXIxEDAOBgNVBAMMB0Nyb3dkZXIxIjAgBgkqhkiG9w0BCQEW
E2luZm9AZ2V0Y3Jvd2Rlci5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEK
AoIBAQDAobCWMQB6aE22AlyecB2HE03sjfjmhKYQgQtkLWNfJvzVPwg5uvqxGhwK
d2obIsE9HtMph+WApbvmVziBac4A9cp7TdC8IMsUyfZKiysoxlFq6NqSmaY7kTML
MC74QPdiIEDwQSWbLherG17/I1+3/LRZszBqJKiiM3MdbYtkWPKkng/GKRoV3U25
sDJbb+EQMFhvVO8ACkBUtFbDeZhoOaiSRl89FpqiA7/J7E5OxZiehaXGy7m4/rDh
qbuuegFQaZx3b+UV0PAxOvaphfu9JRpgFun/CYzFzmu58/L8eQmYH7BjV+RVidYf
fy5dj4jt/Bntv0oOQqxxVhznkTgZAgMBAAGjUzBRMB0GA1UdDgQWBBSSeEUnR10m
Ah8c8baX7DQtC5tOzDAfBgNVHSMEGDAWgBSSeEUnR10mAh8c8baX7DQtC5tOzDAP
BgNVHRMBAf8EBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQCMlmEI1mQab9mABa2Y
NO9JkWuK86eYE+qnOnBdUlCGQtq4gYRqZGlcR36QT5Ayflho+GKNlcN+Y/c+AMm3
RQvRV+JrBUaD/ey9fMiu6eA5l/+br0bsxSCpCZtdyBwFmUlczhCwMzaMXAzCGPww
81kdK8kyRf7Xx3uc2lNJURRbxnllS/BCvbpM54zDT//jGMymSjjy55we3Go5HGfB
z+92H+g/jb270ljJeuw731riyoI8KrPc4KN4lD7yQqO90Op5yc+bn9s8UpJkEqum
HePCuFdWeHNYRsDezAiXMWsuAnlM9plca1DFF+LiIZWqcVZnN3gesFaokWmNbiJ8
XxER
-----END CERTIFICATE-----`;

export const privateKey = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDAobCWMQB6aE22
AlyecB2HE03sjfjmhKYQgQtkLWNfJvzVPwg5uvqxGhwKd2obIsE9HtMph+WApbvm
VziBac4A9cp7TdC8IMsUyfZKiysoxlFq6NqSmaY7kTMLMC74QPdiIEDwQSWbLher
G17/I1+3/LRZszBqJKiiM3MdbYtkWPKkng/GKRoV3U25sDJbb+EQMFhvVO8ACkBU
tFbDeZhoOaiSRl89FpqiA7/J7E5OxZiehaXGy7m4/rDhqbuuegFQaZx3b+UV0PAx
Ovaphfu9JRpgFun/CYzFzmu58/L8eQmYH7BjV+RVidYffy5dj4jt/Bntv0oOQqxx
VhznkTgZAgMBAAECggEBALgCvLj8HkTQFkvjfa4r00kQ+8MY68bot+nUG5mace6X
Q7ZA/A6JuqgrFNY6tDUvwgAszfJCSs3Vg+TJNMUK2Sq5oK6g6uCLQvOc6ZTT1Gqi
52uE/CZGeDE2xtfNM1EaXjZyMRZQZSgTo7Bj+R8oH2uWDoIRVhJO6nfnRfO6jQlQ
9P3VLUaXTELBYFlnOszZ8ELhxu0rcZMMd/SGEynxcc3m54kj75MP5Ojt3hSV7XZo
G9z90A+elghK83mgV4CvydiLVoQfx+4xelOhnyMcl+23lTW36sXK+CgO6KNb6Fd3
HV7uBklMcI3FTDMxIgtiNS/SXhuJyJatwDk0gD56JHECgYEA8HBTASxGuCMWaLju
NIo7ABoKpy2hkNSbZJhyJVdKFf5QxdiYtALdchkMRTkeuoFxJCNd8OurmO7GllF0
EMI7IcWnTxYI9ZdPcUQf46oe2s+umxZwh0KPsmhdxlmrsBYiO5gYJMnfpJkMegU1
8SIvMBaB+incqewgqWB++t45lb8CgYEAzRlHfrHxWpAjiwNPqB+qwe3pVBe8XoTy
AtckDH0pU91vTL/x+Mue8lulplvr6SqwIB/o/YHGIFYlvG18JPkSfKXGiuJZfXJU
pLSxAWk/qePMSv1fqC4dpE9PxBnpxPixkKdg0M7MTISsOvIK/x+FDKCNg+0jM5qs
OzTfE5CemCcCgYEAmWmSDLWLigIZUkhs9OkeLDpxgaoD5L1DSTRb4KeJhe726sYA
6RrK4PpKcgC4MphU8JIAZrB4lOQFofPm8qp7wFi1ICkXHlylO8gT8NejSEorRplS
w3sc5ODitKSSf5Af15Z8ET0djZB5/YFFoc4F/dDerhf3zBP14xzG6JrSc1ECgYAz
pw8raDMJhM1+wAm6pKcDiiA+LnAhOcgdUQNiJc9XsKfMI3cUGmvgS5ZvTC0gnsCW
hpLN7XXxRODiEIy4XwX54GIdLh4tirKofF0rps8CwTz9EcyadWq/q73B/Gi0U5Gc
hZrLW5l2F9+sRLLiR5ThdjnNpNY9s9F2Y71elwhp9wKBgDq7EmQ+8wPUWibuwaTr
2+RdTKpAZJCEJr68dGRpGzgbY7J+pNHZhGwwzHNIFYAiKo3TmLm/xeTdXwoh8Dbd
HOWBELTfpTJE3sb1mhDNLnBLJwFkuraJMkLBBgkYJU1Ioi7gwwCKhJY+D9q5lvh8
7Bp5tTAJACBGAjr42ijJPOu4
-----END PRIVATE KEY-----`;
